import axios from "axios";
import { applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk';
import { rootEpic, rootReducer } from './modules';
import { IUserAuthenticationState } from "./modules/authentication";
import { IHttpRequest } from "application/utils";
import { analyticsMiddleWare } from "../application/middleware";

// eslint-disable-next-line no-underscore-dangle, no-undef
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// custom execution context to pass dependencies to Epics/Thunks
export interface IExecutionContext {
	request: IHttpRequest;
}
const injectContext: IExecutionContext = {
	request: axios as IHttpRequest
}

const epicMiddleware = createEpicMiddleware({
	dependencies: injectContext
});

const thunkMiddleware = thunk.withExtraArgument(injectContext);
// const segmentMiddleware = createTracker();

const configureStore = (initialState) => {
	const middlewares = [thunkMiddleware, epicMiddleware, analyticsMiddleWare];
	const enhancer = composeEnhancers(applyMiddleware(...middlewares));
	const rootStore = createStore(rootReducer, initialState!, enhancer);
	epicMiddleware.run(rootEpic);
	return rootStore;
};


const getStoredState = (): IUserAuthenticationState => {
	const id = localStorage.getItem('current_user_id');
	const accessToken = localStorage.getItem('access_token');
	const expiresAt = localStorage.getItem('access_token_expires_at');
	return { id, accessToken, expiresAt: expiresAt ? Number(expiresAt) : null, idToken: undefined }
}

const storedState = {
	authentication: getStoredState(),
}

const store = configureStore(storedState);
store.subscribe(() => {
	//ToDO:refactor for performance!
	const auth: IUserAuthenticationState = store.getState().authentication;
	localStorage.setItem('current_user_id', auth.id);
	localStorage.setItem('access_token', auth.accessToken);
	localStorage.setItem('access_token_expires_at', auth.expiresAt ? auth.expiresAt.toString() : null);
});

export default () => store;




// WEBPACK FOOTER //
// ./src/store/configureStore.ts